import { useCallback, useEffect, useState } from "react"
import { useDb } from "../../database/database"

interface Props {
    projectId: number | undefined | null
}

// A hook that manages the thumbnail state
// of the project.
export const useThumbnail = ({ projectId }: Props) => {
    const { db } = useDb()
    const [thumbnailData, setThumbnailData] = useState<string | undefined | null>(null)

    // Fetches the thumbnail from the database.
    const fetchThumbnail = useCallback(async () => {
        if (!db || !projectId) return
        const thumbnail = await db.thumbnails.get(projectId)
        setThumbnailData(thumbnail?.thumbnail)
    }, [db, projectId])

    const updateThumbnail = useCallback(
        async (thumbnailData: string) => {
            if (!db || !projectId) return
            await db.thumbnails.put({
                projectId,
                thumbnail: thumbnailData,
            })
            setThumbnailData(thumbnailData)
        },
        [db, projectId]
    )

    useEffect(() => {
        fetchThumbnail()
    }, [db, fetchThumbnail])

    return { thumbnail: thumbnailData, fetchThumbnail, updateThumbnail }
}
